import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { setOpenSnackbar } from '../../store/slices/snackbarSlice';
import ConfirmDialog from '../ConfirmDialog';
import useVrackApi from '../../hooks/useVrackApi';

DeleteWithIcon.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  data: PropTypes.string,
  disabled: PropTypes.bool,
  onDeleted: PropTypes.func,
  toolTipTitle: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  snackBarSuccessMessage: PropTypes.string,
  snackBarFailureMessage: PropTypes.string,
  endpoint: PropTypes.string
};

DeleteWithIcon.defaultProps = {
  type: 'text',
  variant: 'contained',
  color: 'primary'
};

export default function DeleteWithIcon({
  type,
  variant,
  color,
  data,
  disabled,
  onDeleted,
  title,
  content,
  toolTipTitle,
  endpoint,
  snackBarSuccessMessage,
  snackBarFailureMessage
}) {
  const dispatch = useDispatch();
  const userIdentity = useSelector((state) => state.identity.value);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const openSnackbar = (payload) => dispatch(setOpenSnackbar(payload));
  const { fetchData: deleteAction } = useVrackApi('delete', `${endpoint}`);

  const handleDialogCancel = () => {
    setConfirmDialogOpen(false);
  };
  const handleDialogConfirm = async () => {
    await deleteData(data);
    setConfirmDialogOpen(false);
  };
  const handleDialogOpen = (event) => {
    event.stopPropagation();
    setConfirmDialogOpen(true);
  };

  const deleteData = async (data) => {
    console.debug(`Deleting: ${data}`);

    await deleteAction({
      data: {
        identity: userIdentity
      }
    })
      .then((response) => {
        console.debug(`successfully deleted: ${JSON.stringify(response.data)}`);
        openSnackbar({
          message: snackBarSuccessMessage || 'Deleted Data'
        });
        onDeleted?.();
      })
      .catch((error) => {
        console.error(error.message);
        openSnackbar({
          message:
            error?.response?.data?.message && snackBarFailureMessage
              ? `${snackBarFailureMessage}: ${error.response?.data?.message}`
              : snackBarFailureMessage || 'Failed to Delete Data',
          severity: 'error'
        });
      });
  };
  return (
    <>
      <ConfirmDialog
        title={title}
        content={content}
        onCancelHandler={handleDialogCancel}
        onConfirmHandler={handleDialogConfirm}
        isOpen={confirmDialogOpen}
      />
      {type === 'icononly' && (
        <Tooltip title={toolTipTitle} placement="top">
          <IconButton
            variant={variant}
            onClick={handleDialogOpen}
            disabled={disabled}
            color={color}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
}
